import styled from 'styled-components';

export const Container = styled.div`
    margin: 5px;
    border: 1px solid #ddd;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    padding: 10px;
`

export const CreatedAt = styled.div`
    font-weight: bold;
`

export const Message = styled.div`
    font-size: 1em;
    color: #777;
`

export const State = styled.div`
    font-size: 0.8em;
    color: #aaa;
`